if (!customElements.get('static-content-drawer')) {
  customElements.define(
    'static-content-drawer',
    class StaticContentDrawer extends HTMLElement {
      constructor() {
        super();

        const toggleId = this.getAttribute('toggle-id');

        console.log('toggleId', toggleId);

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        const existingDrawer = document.querySelector(`static-content-drawer[toggle-id='${toggleId}']`);
        if (existingDrawer) existingDrawer.remove();
        document.body.appendChild(this);

        const toggle = document.querySelector(`#${toggleId}`) || document.querySelector(`.${toggleId}`);
        if (toggle) {
          toggle.addEventListener('click', (evt) => {
            this.show(evt.target);
          });
        }
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('static-content-drawer') &&
          target.id != 'ToggleStaticContentDrawer' &&
          target.classList.contains('ToggleStaticContentDrawer') == false
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}